<template>
  <div>
    <div v-if="discountList != null">
      <!-- Menu and Filters -->
      <div class="row" style="margin-left: 5px">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4>Discount</h4>
        </div>
      </div>
      <!-- Summary -->
      <div class="row">
        <!-- Total Sales -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="primary" icon="fas fa-chart-line" small-title="Total Sales" 
            :title="new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(discountSummary.totalSales)"/>
        </div>
        <!-- Order Count -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="primary" icon="fas fa-chart-line" small-title="Orders" :title="discountSummary.orderCount.toString()"/>
        </div>
        <!-- AVG Order Value -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="primary" icon="fas fa-chart-line" small-title="AVG Order Value" 
            :title="new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(discountSummary.averageOrderValue)"/>
        </div>
        <!-- Active Code -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="primary" icon="fas fa-chart-line" small-title="Active Code" :title="discountSummary.activeCodeCount.toString()"/>
        </div>
      </div>
      <!-- Data Table -->
      <div class="row">
        <div class="col-md-12">
          <div class="card" style="padding-left: 15px">
            <div class="card-header">
              <h5 class="title" v-if="discountSummary !== null">{{ discountSummary.codeCount }} Discounts</h5>              
              <h5 class="title" v-else>No Discounts</h5>
            </div>
            <div v-if="discountList.length > 0">
              <b-table :items="loadDiscountList" :fields="columns" :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :busy.sync="isLoading">
                <template #table-busy>
                  <div class="text-center" style="margin-top: 10px">
                    <b-spinner class="align-middle" style="margin-right: 10px"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <!-- Code -->
                <template #cell(code)="row">
                  <div style="text-transform: uppercase; font-weight: bold">
                    <a :href="'/shopify/discounts/details/' + row.item._id">{{ row.item.code }}</a>
                  </div>
                </template>
                <!-- Date -->
                <template #cell(date)="row">
                  <div style="overflow-wrap: break-word; font-size: 12px">
                    {{ row.item.dateAddedString }}
                  </div>
                </template>
                <!-- Total Orders -->
                <template #cell(totalOrders)="row">
                  <div>{{ row.item.orderCount }}</div>
                </template>
                <!-- Total Sales -->
                <template #cell(totalSales)="row">
                  <div>
                    {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(row.item.salesTotal) }}
                  </div>
                </template>
                <!-- Avg Order -->
                <template #cell(avgOrder)="row">
                  <div>
                    {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(row.item.salesAvg) }}
                  </div>
                </template>
                <!-- Influencer -->
                <template #cell(influencer)="row">
                  <div style="width: 100%; text-align: center" v-if="row.item.influencer !== undefined">
                    <a :href=" '/influencer-campaign/influencer/' + row.item.influencer._id">
                      <img :src="row.item.influencer.profilePicCache" alt="" class="influencer-img"/>
                    </a>
                    <br/>
                    <a :href=" '/influencer-campaign/influencer/' + row.item._id">
                      {{ row.item.influencer.profileName }}
                    </a>
                  </div>
                </template>
              </b-table>
              <b-col style="width: 500px;padding: 20px;text-align: center;margin: auto">
                <b-pagination v-model="currentPage" :disabled="isLoading" :total-rows="discountSummary.codeCount" :per-page="perPage" align="fill"
                  size="sm" class="my-0"/>
              </b-col>
            </div>
          </div>
          <!-- Rows Table -->
          <div style="padding: 10px; float: left">
            Rows
            <select v-model="perPage" class="custom-select">
              <option v-for="option in ['25', '50']" :value="option" :key="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="lds-dual-ring"></div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import {
  trackingLinkCreateApi,
  userLoadApi,
  userRelatedProfilesApi,
  trackingLinkReadListApi,
  trackingLinkUpdateApi,
  discountCodeSearchDetailedApi,
} from "@/config/appSettings";
import {
  TimeLine,
  TimeLineItem,
  Badge,
  Modal,
} from "src/components/UIComponents";
import { Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
import StatsCard from "@/components/UIComponents/Cards/StatsCard";

export default {
  components: {
    TimeLine,
    TimeLineItem,
    Badge,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Datepicker,
    StatsCard
  },
  data: () => ({
    columns: [
      { key: 'code', label: 'Code', sortable: true, class: 'text-center' },
      { key: 'date', label: 'Date', sortable: false, class: 'text-center' },
      { key: 'totalOrders', label: 'Total Orders', sortable: false, class: 'text-center' },
      { key: 'totalSales', label: 'Total Sales', sortable: false, class: 'text-center' },
      { key: 'avgOrder', label: 'Avg Order', sortable: false, class: 'text-center' },
      { key: 'influencer', label: 'Influencer', sortable: false, class: 'text-center' },
    ],
    isLoading: false,
    currentPage: 1,
    perPage: 25,
    sortBy: 'date',
    sortDesc: true,
    sortDirection: 'asc',
    auth: null,
    discountList: null,
    discountSummary: null
  }),
  name: "TrackingLinks",
  computed: { ...mapGetters(["profileStore", "relatedProfileStore"]) },
  methods: {
    getError(fieldName) {
      //console.log("ERRORS FOUND: ", this.errors.first(fieldName));
      try {
        return this.errors.first(fieldName);
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        try {
          //console.log("CHECKING IS VALID:", isValid);
          //console.log("CHECKING REGISTER FORM: ", this.registerForm);
          this.$emit("on-submit", this.registerForm, isValid);
        } catch (err) {
          console.log("THERE WAS AN ERROR:", err);
        }
      });
    },
    toggleForm() {
      this.showForm = true;
      this.showIntro = false;
    },
    async loadDiscountList() {
      //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
      this.isLoading = true
      try {
        let discountListApiUrl = `${discountCodeSearchDetailedApi}/?usertoken=${this.auth}&shop=${this.$route.params.shop}&page=${this.currentPage}&limit=${this.perPage}`;

        //console.log("SENDING ORDER ANALYTICS URL:", discountListApiUrl);

        let discountListResponse = await axios.get(discountListApiUrl);
        //console.log("DISCOUNT ANALYTICS:", discountListResponse.data);
        if (discountListResponse.data.success == true) {
          this.discountList = discountListResponse.data.result;
          this.discountSummary = discountListResponse.data.summmary;
        }
        this.isLoading = false
        return this.discountList
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    percentDollarString(transactionType) {
      try {
        if (transactionType === "percent") {
          return "% percent";
        }
        if (transactionType === "dollars") {
          return "$ dollars";
        }
        return "";
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      try {
        this.loadDiscountList();
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
  },

  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;

    this.loadPageContent();
  },
  watch: {
    currentPage() {
      this.$root.$emit('bv::refresh::table', 'order-stats-table')
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    perPage() {
      this.$root.$emit('bv::refresh::table', 'order-stats-table')
    }
  }
};
</script>

<style scoped>
.field-bg {
  background-color: white;
  margin: 10px;
}
.influencer-img {
  width: 50px;
  margin: 10px;
  border-radius: 5px;
}
</style>